export class ParamsValueAccessor {
  constructor() {
  }
}
